//libraries
import React, { memo, useContext } from "react";
import isEmpty from "lodash/isEmpty";
import { useLocation } from "react-router-dom";

//components
import MenuItem from "shared/components/Header/DesktopHeader/components/Auth/components/MenuItem";

//context
import { SubNavContext } from "shared/components/SubNav";
import { useAuthModalWrapperContext } from "shared/components/AuthModal/AuthModalWrapperContext";

//constants
import { TEXTS } from "shared/components/Header/DesktopHeader/components/Auth/constants";
import { AUTH_URI } from "shared/constants/uri";

//styles
import { Separator, Greeting, Info, Notification } from "./styles";

//def
interface ILoggedInProps {
    userName: string;
    mobile: string;
    email: string;
    hideEmail: boolean;
    shouldVerifyMobile: boolean;
    shouldVerifyEmail: boolean;
}

function LoggedIn({
    userName,
    mobile,
    email,
    hideEmail,
    shouldVerifyMobile,
    shouldVerifyEmail,
}: ILoggedInProps) {
    const { search, pathname } = useLocation();
    const params = new URLSearchParams(search);
    const { doHide } = useContext(SubNavContext);
    const { showAuthModal } = useAuthModalWrapperContext();

    const goToMyOrder = () => {
        doHide();
        window.location.href = "/sales/order/history";
    };

    const goToWishlist = () => {
        doHide();
        window.location.href = "/wishlist";
    };

    const logout = () => {
        doHide();
        window.location.href = "/customer/account/logout";
    };

    const clickHandler = (requiredURI: string) => {
        params.set(AUTH_URI.PARAM_KEY, requiredURI);
        const url = pathname + "?" + params.toString();
        doHide();

        showAuthModal(url);
    };

    return (
        <>
            <Greeting>{TEXTS.HI_USER(userName)}</Greeting>
            {isEmpty(mobile) === false && <Info>{mobile}</Info>}
            {isEmpty(email) === false && hideEmail === false && <Info>{email}</Info>}
            {shouldVerifyMobile === true && (
                <Notification onClick={() => clickHandler(AUTH_URI.MOBILE_NUMBER_VERIFICATION)}>
                    {TEXTS.VERIFY_MOBILE_LABEL}
                </Notification>
            )}
            {shouldVerifyEmail === true && (
                <Notification onClick={() => clickHandler(AUTH_URI.MERGE_ACCOUNTS)}>
                    {TEXTS.VERIFY_EMAIL_LABEL}
                </Notification>
            )}
            <Separator showBorder={shouldVerifyEmail === false && shouldVerifyMobile === false} />
            <MenuItem onClick={goToMyOrder} iconClassName="icon-orders" title={TEXTS.MY_ORDER} />
            <MenuItem onClick={goToWishlist} iconClassName="icon-heart" title={TEXTS.MY_WISHLIST} />
            <MenuItem onClick={logout} iconClassName="icon-log-out" title={TEXTS.LOGOUT} />
        </>
    );
}

export default memo(LoggedIn);
